import React from 'react'

const BinnacleContext = React.createContext({ handleForm: undefined,
  handleChange: undefined,
  handleSave: undefined })
export default BinnacleContext
